import { inject, Injectable } from '@angular/core';
import { InfoApiService } from './api/info-api.service';
import { map, Observable } from 'rxjs';
import { InfoDto } from '../../shared/models/info/info-dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SupportContactService {
  private infoApi = inject(InfoApiService);
  private defaultSubject = 'AEDBIS-Support';

  public getSupportMailLink$(subject = this.defaultSubject): Observable<string> {
    return this.infoApi.getInfo().pipe(map((info) => this.buildMailUrlWithSystemInfo(info, subject)));
  }

  public fallbackMailUrl(): string {
    return this.buildMailUrlWithSystemInfo({ versionInfo: undefined, environment: undefined }, this.defaultSubject);
  }

  public getSupportMailLink(body: string, subject: string = this.defaultSubject): string {
    return encodeURI(`mailto:${environment.supportMailAddress}?subject=${subject}&body=${body}`);
  }

  private buildMailUrlWithSystemInfo(info: InfoDto, mailSubject: string): string {
    const url = window.location.href;

    const body = [
      '\n',
      'System information:',
      `BE: ${info.versionInfo ?? 'unknown'}`,
      `FE: ${environment.versionInfo}`,
      `ENV: ${info.environment ?? 'unknown'}`,
      `URL: ${url}`,
    ].join('\n');

    return this.getSupportMailLink(body, mailSubject);
  }
}
